import { render, staticRenderFns } from "./ChooseTags.vue?vue&type=template&id=502e80d7&scoped=true&"
import script from "./ChooseTags.vue?vue&type=script&lang=js&"
export * from "./ChooseTags.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTags.vue?vue&type=style&index=0&id=502e80d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e80d7",
  null
  
)

export default component.exports